/* eslint-disable react/require-default-props, no-unused-vars */
import PropTypes from 'prop-types'
import { createTypeElement, createPropTypes } from './util'

const Text = ({ as = 'span', size = 'large', ...props }) =>
  createTypeElement('Text', { as, size, ...props })

Text.propTypes = createPropTypes({
  size: PropTypes.oneOf(['large', 'small', 'tiny']),
})

export default Text
